import { Routes, Route } from "react-router-dom";

import Fleets from "./Fleets";
import FleetCreateEdit from "./FleetCreateEdit";
import FleetDetails from "./FleetDetails";

const index = () => {
	return (
		<Routes>
			<Route index element={<Fleets />} />
			<Route path='/create' element={<FleetCreateEdit />} />
			<Route path='/:id/edit' element={<FleetCreateEdit />} />
			<Route path='/:id/details' element={<FleetDetails />} />
		</Routes>
	);
};

export default index;
